import config from 'config';
import axios from 'helpers/axios';

const spreadsheetRequests = ({ applicationIds, projectId }) =>
  axios({
    method: 'post',
    url: `${config.apiUrl}/applications/spreadsheet_bulk`,
    responseType: 'blob', // important
    data: {
      applicationIds,
      projectId,
    },
  });

export default spreadsheetRequests;
